import { JSON_CONTENT_TYPE } from '../../state/graphqlEndpoints';
import { QueryBuilderError } from './errors';

export async function queryBuilderRequest<T>(path: string, body?: unknown): Promise<T> {
	const response = await fetch(`/gateway/api/${path}`, {
		method: body === undefined ? 'GET' : 'POST',
		credentials: 'include',
		headers: { 'Content-Type': JSON_CONTENT_TYPE },
		...(body === undefined ? {} : { body: JSON.stringify(body) }),
	});
	const data = await response.json();
	if (!response.ok || data.errors?.length) {
		if (path === 'twg/cypher-queries' && response.status === 400 && data.errors?.length) {
			throw new QueryBuilderError('savedInvalid');
		}
		throw new Error(
			data.errors?.map((error: { message: string }) => error.message).join('\n') ||
				`Unable to load Query Builder data (${response.status}).`,
		);
	}
	if (path === 'twg/cypher-queries' && response.status === 200) {
		throw new QueryBuilderError('savedExists');
	}
	return data;
}

export async function queryBuilderGraphQL<T>(
	operationName: string,
	query: string,
	variables: Record<string, unknown> = {},
): Promise<T> {
	const response = await queryBuilderRequest<{ data: T }>('graphql', {
		operationName,
		query,
		variables,
	});
	if (!response.data) {
		throw new Error('Query Builder received an empty response.');
	}
	return response.data;
}
